import { SpawnerBuilding } from "./SpawnerBuilding";
import type { DefeatContext } from "./context";

export class Chapel extends SpawnerBuilding {
    readonly id = "chapel";
    readonly displayName = "Chapel";
    readonly spawns = "priest";
    readonly maxSpawns = 2;
    description() { return "Spawns priests\nProvides many souls when destroyed."; }
    maxCooldown() { return 8000; }
    onDefeat(ctx: DefeatContext) { ctx.game.addResource(ctx.attacker.faction, "souls", 20); }
}
